import styled from 'styled-components';
import { Pagination as pagination } from 'antd';

const Pagination = styled(pagination)`
  margin-top: 24px;
  float: right !important;

  .ant-pagination-item-link {
    border: none !important;
    color: #8e8e8e;
  }

  .ant-pagination-item {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    color: #1d1d1f;

    &-active {
      border: 1px solid #1e61e6;

      a,
      &:hover a {
        color: white;
      }
    }

    &:hover {
      background: #efefef;
      color: #626469;

      a {
        color: #626469 !important;
      }
    }

    &:focus {
      background: #e0e0e0;
      color: #626469;

      a {
        color: #626469 !important;
      }
    }
  }
`;

/** @component */
export default Pagination;
